import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class ConnectedServiceService {
  baseUrl = 'connected-service';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}` });
  sync = (dto) => BaseService.post({ url: `${this.baseUrl}/sync`, data: dto });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  create = (dto) => BaseService.post({ url: `${this.baseUrl}`, data: dto });
  update = (id, dto) => BaseService.put({ url: `${this.baseUrl}/${id}`, data: dto });
  getWinbizFolders = (id) => BaseService.get({ url: `${this.baseUrl}/winbiz/folders/${id}` });
  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
  syncWyzio = (id, syncParams) => BaseService.post({ url: `${this.baseUrl}/wyzio/sync/${id}`, data: syncParams });
}

export default new ConnectedServiceService();
